import { useCallback } from "react";

export type TWebsiteBuilderActivePageDomNodeRefMap = React.MutableRefObject<Map<string, HTMLDivElement>>;

export function useActivePageDomNodeRefMapRegistration(id: string, activePageDomNodeRefMap: TWebsiteBuilderActivePageDomNodeRefMap) {
  return useCallback(
    (el: HTMLDivElement) => {
      if (el != null) {
        activePageDomNodeRefMap.current.set(id, el);
      } else {
        activePageDomNodeRefMap.current.delete(id);
      }
    },
    [id],
  );
}
